import React from 'react';

import { Box } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

export type IconWithTextProps = {
  icon: React.ReactNode;
  textMargin?: number;
  className?: string;
  placement?: 'start' | 'end';
  alignTop?: boolean;
  testId?: string;
};

export const IconWithText = React.forwardRef<HTMLDivElement, React.PropsWithChildren<IconWithTextProps>>(({ icon, children, className, alignTop, textMargin = 1, placement = 'start', testId = 'icon-with-text' }, ref) => {
  const { classes, cx } = useStyles({ textMargin, placement, alignTop });

  return (
    <div ref={ref} className={cx(classes.root, className)} data-testid={testId}>
      {placement === 'start' && icon}
      <Box className={classes.container}>
        {children}
      </Box>
      {placement === 'end' && icon}
    </div>
  );
});

const useStyles = makeStyles<Partial<IconWithTextProps>>({ name: 'IconWithText' })((theme, { placement, textMargin }) => ({
  root: {
    alignItems: 'center',
    display: 'inline-flex'
  },
  container: ({
    display: 'inline-block',
    [placement === 'start' ? 'marginLeft' : 'marginRight']: theme.spacing(textMargin ?? 1)
  })
}));
